{
  "metadata": {
    "id": "oc-2-dark",
    "name": "OC-2",
    "description": "Портировано из темы «OC-2» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "oc-2.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/oc-2.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 22.8,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.476,
      "paletteMaxS": 0.517,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.1,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 18.5,
      "syntaxVsTextMinDeltaE": 16.6,
      "chartsMinDeltaE": 47.6,
      "textSeparationDeltaE": 26.8,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#fab283",
      "hover": "#fbbb92",
      "active": "#fbc19c",
      "foreground": "#000000",
      "muted": "#fab28380",
      "emphasis": "#fab283"
    },
    "surface": {
      "background": "#1f1f1f",
      "foreground": "#f1ece8",
      "muted": "#313130",
      "mutedForeground": "#a3a3a3",
      "elevated": "#3a3a39",
      "elevatedForeground": "#f1ece8",
      "raised": "#535251",
      "raisedForeground": "#f1ece8",
      "overlay": "#1f1f1fcc",
      "subtle": "#292828"
    },
    "interactive": {
      "border": "#565453",
      "borderHover": "#5a5857",
      "borderFocus": "#fab283",
      "selection": "#f1ece829",
      "selectionForeground": "#f1ece8",
      "focus": "#fab28359",
      "focusRing": "#fab28361",
      "cursor": "#ededed",
      "hover": "#f1ece81c",
      "active": "#f1ece829"
    },
    "status": {
      "error": "#fc533a",
      "errorForeground": "#000000",
      "errorBackground": "#fc533a24",
      "errorBorder": "#fc533a73",
      "warning": "#fcd53a",
      "warningForeground": "#000000",
      "warningBackground": "#fcd53a24",
      "warningBorder": "#fcd53a73",
      "success": "#12c905",
      "successForeground": "#000000",
      "successBackground": "#12c90524",
      "successBorder": "#12c90573",
      "info": "#edb2f1",
      "infoForeground": "#000000",
      "infoBackground": "#edb2f124",
      "infoBorder": "#edb2f173"
    },
    "pr": {
      "open": "#12c905",
      "draft": "#b0b0b0",
      "blocked": "#fcd53a",
      "merged": "#fab283",
      "closed": "#fc533a"
    },
    "syntax": {
      "base": {
        "background": "#434241",
        "foreground": "#f1ece8",
        "comment": "#afafcf",
        "keyword": "#edb2f1",
        "string": "#00ceb9",
        "number": "#93e9f6",
        "function": "#fab283",
        "variable": "#f1ece8",
        "type": "#fcd53a",
        "operator": "#cccccc"
      },
      "tokens": {
        "commentDoc": "#afafcf",
        "stringEscape": "#cccccc",
        "keywordImport": "#edb2f1",
        "storageModifier": "#edb2f1",
        "functionCall": "#fab283",
        "method": "#fab283",
        "variableProperty": "#fab283",
        "variableOther": "#f1ece8",
        "variableGlobal": "#93e9f6",
        "variableLocal": "#cccccc",
        "parameter": "#f1ece8",
        "constant": "#93e9f6",
        "class": "#fcd53a",
        "className": "#fcd53a",
        "interface": "#fcd53a",
        "struct": "#fcd53a",
        "enum": "#fcd53a",
        "typeParameter": "#fcd53a",
        "namespace": "#fcd53a",
        "module": "#edb2f1",
        "tag": "#edb2f1",
        "jsxTag": "#edb2f1",
        "tagAttribute": "#fab283",
        "tagAttributeValue": "#00ceb9",
        "boolean": "#93e9f6",
        "decorator": "#edb2f1",
        "label": "#fab283",
        "regexp": "#00ceb9"
      }
    },
    "charts": {
      "series": [
        "#fab283",
        "#edb2f1",
        "#12c905",
        "#fcd53a",
        "#fc533a"
      ]
    },
    "chat": {
      "background": "#1f1f1f",
      "userMessage": "#f1ece8",
      "userMessageBackground": "#3a3a39",
      "assistantMessage": "#f1ece8",
      "assistantMessageBackground": "#313130",
      "timestamp": "#b0b0b0",
      "divider": "#565453",
      "typing": "#b0b0b0"
    },
    "loading": {
      "spinner": "#fab283",
      "spinnerTrack": "#313130",
      "skeleton": "#313130",
      "shimmer": "#4d4c4b"
    },
    "tools": {
      "background": "#313130",
      "border": "#565453",
      "headerHover": "#4c4a49",
      "icon": "#fab283",
      "title": "#f1ece8",
      "description": "#b0b0b0",
      "edit": {
        "added": "#12c905",
        "addedBackground": "#12c90524",
        "removed": "#fc533a",
        "removedBackground": "#fc533a24",
        "modified": "#edb2f1",
        "modifiedBackground": "#edb2f124",
        "lineNumber": "#b0b0b0"
      }
    },
    "markdown": {
      "heading1": "#f1ece8",
      "heading2": "#f1ece8",
      "heading3": "#f1ece8",
      "heading4": "#f1ece8",
      "link": "#fab283",
      "linkHover": "#fbbb92",
      "inlineCode": "#00ceb9",
      "inlineCodeBackground": "#313130",
      "blockquote": "#b0b0b0",
      "blockquoteBorder": "#565453",
      "listMarker": "#fab283bf",
      "bold": "#f1ece8",
      "italic": "#f1ece8e6",
      "strikethrough": "#b0b0b0",
      "hr": "#565453"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c8675d",
        "foreground": "#000000",
        "contrast": 5.55
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#e0b2a3",
        "foreground": "#000000",
        "contrast": 11.07
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#ceb367",
        "foreground": "#000000",
        "contrast": 10.27
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#d6dfac",
        "foreground": "#000000",
        "contrast": 15.01
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#a0c66e",
        "foreground": "#000000",
        "contrast": 10.8
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#69ce67",
        "foreground": "#000000",
        "contrast": 10.63
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#6fc590",
        "foreground": "#000000",
        "contrast": 10.07
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#a7e3d4",
        "foreground": "#000000",
        "contrast": 14.58
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#67b8cc",
        "foreground": "#000000",
        "contrast": 9.3
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#5f90c8",
        "foreground": "#000000",
        "contrast": 6.31
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#575fc3",
        "foreground": "#ffffff",
        "contrast": 5.48
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#9985d2",
        "foreground": "#000000",
        "contrast": 6.64
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a35ec6",
        "foreground": "#000000",
        "contrast": 4.97
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#d6a8da",
        "foreground": "#000000",
        "contrast": 10.47
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#c960a6",
        "foreground": "#000000",
        "contrast": 5.71
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d5879c",
        "foreground": "#000000",
        "contrast": 7.77
      }
    ]
  }
}
